// Pulls the first error-code string out of an axios-shaped error. Backend may return either
// `error: "<code>"` (top-level) or `error: { <field>: [{ error: "<code>" }] }` (per-field
// validation map); we accept both shapes and surface the first usable code.
export const extractErrorCode = (error: unknown): string | null => {
  const data = (error as { response?: { data?: { error?: unknown } } })?.response?.data?.error;
  if (typeof data === "string") return data;
  if (data && typeof data === "object") {
    for (const key of Object.keys(data)) {
      const arr = (data as Record<string, unknown>)[key];
      if (Array.isArray(arr)) {
        const first = arr[0];
        if (first && typeof first === "object" && typeof (first as { error?: unknown }).error === "string") {
          return (first as { error: string }).error;
        }
      }
    }
  }
  return null;
};

// Error codes returned by POST /registrations and POST /patient_authentications when the
// OTP code itself is the problem (as opposed to validation / network / generic errors).
export const OTP_ERROR_CODES = new Set(["invalid_code", "code_expired", "attempts_exceeded"]);

export const isOtpErrorCode = (code: string | null): boolean => code !== null && OTP_ERROR_CODES.has(code);
